// extracted by mini-css-extract-plugin
module.exports = {"fullSection":"FullSection-module--fullSection--3pHs9","fullSectionInner":"FullSection-module--fullSectionInner---FBZR"};